import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: 'article/:article_id', loadComponent: () => import('./article/article.component').then(c => c.ArticleComponent) }
];
